<div>
    <app-filter-view [dropdownListBO]="dropdownListBO" [dropdownListOrderCluster]="dropdownListOrderCluster"
        [dropdownListCustomer]="dropdownListCustomer" [dropdownListCountry]="dropdownListCountry"
        [dropdownListMonth]="dropdownListMonth" [dropdownListYear]="dropdownListYear"
        [dropdownListOrderType]="dropdownListOrderType" [orderTypeOfOrderCLuster]="orderTypeOfOrderCLuster"
        [customerOfCountry]="customerOfCountry" [selectedItemsBO]="selectedItemsBO"
        [selectedItemsOrderCluster]="selectedItemsOrderCluster" [selectedItemsCustomer]="selectedItemsCustomer"
        [selectedItemsCountry]="selectedItemsCountry" [selectedItemsMonth]="selectedItemsMonth"
        [selectedItemsYear]="selectedItemsYear" [selectedItemsOrderType]="selectedItemsOrderType"
        [idLeadGlobalOfCustomerName]="idLeadGlobalOfCustomerName" [selectedItemsIdGlobal]="selectedItemsIdGlobal"
        [dropdownListOrderStatus]="dropdownListOrderStatus" [dropdownListLead]="dropdownListLead"
        [selectedItemsOrderStatus]="selectedItemsOrderStatus" [selectedItemsLead]="selectedItemsLead"
        [viewMonth]="viewMonth" [viewOrderStatus]="viewOrderStatus" [overviewOrderdDetailReportSpan]="false"
        [slaKpiSpan]="true" [completedDetailSpan]="false" (sendFilterEvent)="loadReport($event)"
        (updateFilterEvent)="updateFilterEvent($event)">
    </app-filter-view>
</div>
<div class="d-flex justify-content-start mt-4" *ngIf="viexExportPdf()">
    <button class="btn btn-primary btn-lg active btn-sm reset-style" (click)="initializeTendine()">RESET ALL
        FILTERS</button>

    <button class="btn btn-primary btn-lg active btn-sm logout-style" (click)="htmltoPDF()">EXPORT PDF</button>
</div>
<div class="d-flex align-items-center" #reportSlaKpis style="margin-top:4%;">

    <div class="chartClass" *ngIf="viewSlaKpi()">
        <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
            [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend" [colors]="colors">
        </canvas>
    </div>

    <div class="chartClass" *ngIf="viewSlaKpiOnlyRespected()">
        <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
            [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend" [colors]="colorsOnlyRespected">
        </canvas>
    </div>

    <div class="chartClass" *ngIf="viewSlaKpiOnlyNotRespected()">
        <canvas baseChart [data]="pieChartData" [labels]="pieChartLabels" [chartType]="pieChartType"
            [options]="pieChartOptions" [plugins]="pieChartPlugins" [legend]="pieChartLegend" [colors]="colorsOnlyNot">
        </canvas>
    </div>

    <div class="d-flex flex-column" >
        <div class="card-dimension-title">
            <div class="card-body card-body-style-title" style="text-align: center!important; ">
                <p style="color:#2b2b2b; " class="card-text font-style-size-title">Average time to completion
                </p>
            </div>
        </div>


        <div class="card-dimension">
            <div class="card-body card-body-style">
                <p style="color:#2b2b2b; " class="card-text font-style-size-number">
                    {{getSumCompleted()}}</p>
                <p style="color:#66FF66;" class="card-text font-style-size">Completed</p>

            </div>
        </div>

    </div>


</div>